export default __webpack_public_path__ + "static/media/strong 8 mobilityflows.2aa9bc4a.png";